<template>
  <div>
    <ActiveDealsChart
      class="chart-container"
      :options="options"
      :chart-data="datacollection"
      :height="64"
    />
  </div>
</template>

<script>
import ActiveDealsChart from './ActiveDealsChart'

export default {
  components: {
    ActiveDealsChart
  },
  data() {
    return {
      datacollection: null,
      options: null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      let labels = []
      let range = 24
      let data = []

      // Prefill data
      for (let i = 0; i < range; i++) {
        if (i < 12) {
          labels[i] = `${i}AM`
        } else {
          labels[i] = `${i}PM`
        }

        // data[i] = Math.floor(Math.random() * 30)
        data[i] = 0.4
      }

      this.datacollection = {
        labels,
        datasets: [
          {
            backgroundColor: this.getDatasetColors(labels),
            data
          }
        ]
      }
      this.options = {
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: false
            }
          ],
          yAxes: [
            {
              display: false
            }
          ]
        }
      }
    },
    getDatasetColors(labels) {
      // Random position... later on it will be a meaningful position
      // const labelsRandom = Math.floor(Math.random() * labels.length)
      const colors = []

      for (let i = 0; i < labels.length; i++) {
        colors.push('#00A69C')
      }

      // colors[labelsRandom] = '#FF4060'

      return colors
    }
  }
}
</script>

<style scoped lang="sass">
.chart-container
  margin-bottom: -14px
</style>
